import { Link } from 'react-router-dom'
import Seo from '@/components/Seo'
import { faqSchema } from '@/components/FaqList'
import FaqSearch from '@/components/FaqSearch'
import AdSlot from '@/components/AdSlot'
import { FAQS } from '@/data/faqs'

function Faq() {
  return (
    <>
      <Seo
        title="Dormer Calculator FAQ: Cost, Planning, Pitch and Accuracy"
        description="Answers to common dormer questions: how much a dormer costs, whether you need planning permission, shed vs gable, roof pitch and how accurate the calculator is."
        path="/faq"
        schema={faqSchema(FAQS)}
      />
      <div className="border-b border-steel-200 bg-white">
        <div className="container-page py-10">
          <p className="eyebrow">Help</p>
          <h1 className="mt-2 text-3xl sm:text-4xl lg:text-5xl">Frequently asked questions</h1>
          <p className="mt-3 max-w-2xl text-lg">Quick answers about dormer costs, rules, design and how to use the calculator.</p>
        </div>
      </div>
      <div className="container-page py-10">
        <div className="mx-auto max-w-3xl">
          <FaqSearch items={FAQS} />
          <div className="mt-10">
            <AdSlot variant="banner" />
          </div>
          <div className="card mt-6 bg-ink p-6 text-white">
            <h2 className="text-xl !text-white">Still have a question?</h2>
            <p className="mt-2 text-blueprint-100">Try the calculator with your own numbers and see the full cost breakdown.</p>
            <div className="mt-4 flex flex-wrap gap-3">
              <Link to="/calculator" className="btn btn-primary no-underline">Open calculator</Link>
              <Link to="/blog" className="btn btn-outline-light no-underline">Read the guides</Link>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Faq
